import { render, staticRenderFns } from "./past-prescriptions.vue?vue&type=template&id=028186ba&"
import script from "./past-prescriptions.vue?vue&type=script&lang=js&"
export * from "./past-prescriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports